import { render, staticRenderFns } from "./GlobalSearchView.vue?vue&type=template&id=deef3da6"
import script from "./GlobalSearchView.vue?vue&type=script&lang=js"
export * from "./GlobalSearchView.vue?vue&type=script&lang=js"
import style0 from "./GlobalSearchView.vue?vue&type=style&index=0&id=deef3da6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports